/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { Tooltip } from '@blend/react-tippy';
import { mixins, colors } from '@blend/consumer-components';
import { zIndex } from '../../../style/zIndex';

const PopoverOffset = 15;

const styles = StyleSheet.create({
  PopoverContainer: {
    ...mixins.padding(8),
    boxShadow: mixins.boxShadow(0, 2, 4, 0, mixins.fade(colors.black, 0.15)),
    backgroundColor: colors.white,
    zIndex: zIndex.popover,
    borderRadius: 4,
    textAlign: 'left',
  },
});

export namespace Popover {
  // subset of supported Position in 'react-tippy'
  export type AnchorPosition =
    | 'bottom-start'
    | 'bottom'
    | 'bottom-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'top-start'
    | 'top-end';
  export interface Props {
    anchorPosition: AnchorPosition;
    popoverContent: JSX.Element;
    onClose: () => void;
    isOpen: boolean;
    children: React.ReactElement | React.ReactElement[];
  }
}

export const Popover: React.FC<Popover.Props> = ({ popoverContent, anchorPosition, isOpen, onClose, children }) => {
  const getPopoverHTML = () => {
    return <div className={css(styles.PopoverContainer)}>{popoverContent}</div>;
  };

  return (
    <Tooltip
      arrow={false}
      interactive
      sticky
      useContext
      transitionFlip={false}
      trigger="manual"
      open={isOpen}
      stickyDuration={0}
      html={getPopoverHTML()}
      position={anchorPosition}
      distance={PopoverOffset}
      hideDuration={0}
      theme="primary"
      onRequestClose={onClose}
      style={{ display: 'flex' }}
    >
      {children}
    </Tooltip>
  );
};
